import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import IncreaseEngagementImage from './IncreaseEngagementImage'

const copy = {
  heading: `Increase engagement and drive repeat purchases`,
  description: `Integrate tools for push notifications, A/B testing, and email to help bring users back to your app at the right time.`,
}

const IncreaseEngagement: FC = () => {
  return (
    <Wrapper>
      <SectionBase variant="2Col">
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description variant="pLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </SectionCopy>
        <Section.Contents>
          <IncreaseEngagementImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default IncreaseEngagement
